import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { usePWA } from '../hooks/usePWA';
import { LoadingSpinner } from './LoadingSpinner'; // Assuming you have a generic loading spinner or use a simple fallback

interface AuthGateProps {
    children: React.ReactNode;
}

export const AuthGate: React.FC<AuthGateProps> = ({ children }) => {
    const { isSignedIn, isLoaded } = useAuth();
    const { isPWA } = usePWA();

    // Wait for Clerk to load auth state to avoid premature redirects
    if (!isLoaded) {
        return <LoadingSpinner />;
    }

    // Logic:
    // 1. If PWA -> Allow access regardless of auth status (user logic inside handles 'guest' vs 'user')
    // 2. If Web -> MUST be signed in. If not, redirect to sign in.

    if (isPWA) {
        return <>{children}</>;
    }

    if (isSignedIn) {
        return <>{children}</>;
    }

    // Web + Not Signed In -> Redirect to our custom login page
    return <Navigate to="/login" replace />;
};
